export const BASE_URL = "https://testalp.i.excentio.com/";
export const SIGNUP_URL = "api/v2/cognito/signup";
export const primaryColor = "#ee7050";
export const secondColor = "#f0b560";
export const thirdColor = "#3e798d";
export const GOOGLE_API_KEY = "AIzaSyDHRv2gGYrtxYBAEt5TOfEGf80uko4CxqQ";
